import { css } from 'lit';

// Only what the graphic pattern designer's styles don't already cover.
export const styles = css`
  .image-summary {
    display: flex;
    flex-direction: column;
    gap: var(--designer-label-gap);
  }

  .image-summary__title {
    margin: 0;
    font-size: var(--fs-body);
    line-height: var(--lh-body);
    font-weight: var(--fw-medium);
  }

  .image-summary__description {
    margin: 0;
    font-size: var(--fs-label-small);
    line-height: var(--lh-label-small);
    color: var(--designer-control-muted);
  }

  .image-actions {
    display: flex;
    flex-wrap: wrap;
    gap: var(--designer-label-gap);
  }

  .image-action {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-height: var(--designer-control-height);
    padding: 0 calc(16rem / var(--default-rem-px-count));
    border: 1px solid var(--designer-control-border);
    background: transparent;
    color: inherit;
    font: inherit;
    text-decoration: none;
    cursor: pointer;
  }

  .image-action:focus-within {
    outline: 2px solid var(--block-text-color, #222222);
    outline-offset: 2px;
  }

  .editor-frame {
    display: block;
    width: 100%;
    aspect-ratio: 4 / 3;
    border: 1px solid var(--designer-panel-border);
    background: var(--block-bg-color, #ffffff);
  }

  .start-intro {
    margin: 0;
    font-size: var(--fs-body);
    line-height: var(--lh-body);
    color: var(--designer-control-muted);
  }

  .upload-box {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: var(--designer-label-gap);
    padding: calc(32rem / var(--default-rem-px-count))
      calc(24rem / var(--default-rem-px-count));
    border: 1px dashed var(--designer-control-border);
    text-align: center;
    cursor: pointer;
  }

  .upload-box > * {
    pointer-events: none;
  }

  .upload-box.is-dragging {
    border-style: solid;
    border-color: var(--block-text-color, #222222);
    background: #f5f5f5;
  }

  .upload-box:focus-within {
    outline: 2px solid var(--block-text-color, #222222);
    outline-offset: 2px;
  }

  .upload-box__icon {
    display: flex;
    align-items: center;
    justify-content: center;
    width: calc(44rem / var(--default-rem-px-count));
    height: calc(44rem / var(--default-rem-px-count));
    border-radius: 50%;
    background: #eeeeee;
  }

  .upload-box__title {
    font-size: var(--fs-body);
    line-height: var(--lh-body);
    font-weight: var(--fw-medium);
  }

  .upload-box__hint {
    font-size: var(--fs-label-small);
    line-height: var(--lh-label-small);
    color: var(--designer-control-muted);
  }

  .upload-box__formats,
  .upload-box__note {
    font-size: calc(12rem / var(--default-rem-px-count));
    line-height: calc(16rem / var(--default-rem-px-count));
    color: var(--designer-control-muted);
  }

  .upload-box .image-action {
    margin: calc(6rem / var(--default-rem-px-count)) 0;
  }

  .panel-size,
  .status-note {
    margin: 0;
    font-size: var(--fs-label-small);
    line-height: var(--lh-label-small);
    color: var(--designer-control-muted);
  }
`;
